import {
    LOAD_ALL_EMAIL_TEMPLATES,
    REMOVE_EMAIL_TEMPLATE_BY_ID,
    LOAD_EMAIL_TEMPLATE_BY_ID,
    ERROR_LOAD_EMAIL_TEMPLATE_BY_ID,
    EDIT_EMAIL_TEMPLATE_BY_ID,
    ERROR_EDIT_EMAIL_TEMPLATE_BY_ID,
  } from '../../actions/emailTemplate';

export default function emailTemplate(state = {}, action) {
    switch (action.type) {
        case LOAD_ALL_EMAIL_TEMPLATES:
            return Object.assign({}, state, action.payload);
        case REMOVE_EMAIL_TEMPLATE_BY_ID:
            for (let i = 0; i < state.list.length; i++) {
                if (state.list[i].id == action.payload.id) {
                state.list.splice(i, 1);
                }
            }
          return Object.assign({}, state, action.payload);
        case LOAD_EMAIL_TEMPLATE_BY_ID:
            return Object.assign({}, state, action.payload);
        case ERROR_LOAD_EMAIL_TEMPLATE_BY_ID:
            return Object.assign({}, state, action.payload);
        case EDIT_EMAIL_TEMPLATE_BY_ID:
            return Object.assign({}, state, action.payload);
        case ERROR_EDIT_EMAIL_TEMPLATE_BY_ID:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/emailTemplate/index.js